import React, { FC, useCallback } from 'react';
import { OperatorProps } from '../../../../@types/TemplateOperators';
import { ArgsInput, ArgsSelect } from './BasicComponents';

import { getColumnDropDownOptions, validateColumnInitValue } from './utils';

export enum PrependModes {
  PREPEND = 'PREPEND',
  PREPEND_TO = 'PREPEND_TO'
}

const PrependCases = [
  { label: 'PREPEND', value: 'PREPEND' },
  { label: 'PREPEND_TO', value: 'PREPEND_TO' }
];

const Prepand: FC<OperatorProps> = ({ step, handleArgsChange, dropDownOptions }) => {
  const [prependMode, defaultValue] = step.args;

  const options = getColumnDropDownOptions(dropDownOptions);
  const columnInitialValue = validateColumnInitValue(defaultValue, options.length);

  const modeChangeHandler = useCallback(
    (value: string | number): void => {
      handleArgsChange([value]);
    },
    [handleArgsChange]
  );

  const argsChangeHandler = useCallback(
    (value: string | number): void => {
      handleArgsChange([prependMode, value]);
    },
    [handleArgsChange, prependMode]
  );

  return (
    <div data-testid="Prepand-component">
      <div className="flex mt-6 w-1/2">
        <ArgsSelect
          argsSelectLabel="mode"
          options={PrependCases}
          onChange={modeChangeHandler}
          value={prependMode || ''}
          label="Prepend to some field, or prepend value from previous step"
        />
      </div>
      {prependMode === PrependModes.PREPEND && (
        <div className="flex mt-6 w-1/2">
          <ArgsInput
            initialValue={defaultValue || ''}
            onChange={argsChangeHandler}
            label="prepend"
            subLabel="Value to be prepended"
          />
        </div>
      )}
      {prependMode === PrependModes.PREPEND_TO && (
        <div className="flex my-6 w-1/2">
          <ArgsSelect
            argsSelectLabel="column"
            options={options}
            onChange={argsChangeHandler}
            value={columnInitialValue}
            label="Column to prepend value to"
            maxVisible={2}
          />
        </div>
      )}
    </div>
  );
};

export default Prepand;
